import { render, staticRenderFns } from "./currency-sources.vue?vue&type=template&id=05733aae&scoped=true&"
import script from "./currency-sources.vue?vue&type=script&lang=js&"
export * from "./currency-sources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05733aae",
  null
  
)

export default component.exports